"use client";

import React, { useMemo } from "react";
import CountryPhonePrompt from "./CountryPhonePrompt";
import { useLanguage } from "@/contexts/LanguageContext";
import { getStrings } from "@/i18n/dictionaries";

/**
 * Component to display when user tries Uganda MoMo with non-Ugandan phone
 * This is a wrapper around CountryPhonePrompt with Uganda-specific configuration
 */
export default function UgandaPhonePrompt({
  onClose,
  onSwitchToStripe,
  detectedPhone,
  authPhone,
  profilePhone,
  profileCountry,
  selectedPaymentCountry,
}) {
  const { locale } = useLanguage();
  const t = useMemo(() => getStrings(locale, "payment"), [locale]);
  const ugandaConfig = {
    title: t.uganda_phone_title,
    requiredPrefix: "+256",
    requiredCountryName: "Uganda",
  };

  return (
    <CountryPhonePrompt
      onClose={onClose}
      onSwitchToStripe={onSwitchToStripe}
      onSwitchToBankTransfer={null}
      detectedPhone={detectedPhone}
      authPhone={authPhone}
      profilePhone={profilePhone}
      profileCountry={profileCountry}
      selectedPaymentCountry={selectedPaymentCountry}
      config={ugandaConfig}
    />
  );
}
